import { render, staticRenderFns } from "./FuelItem.vue?vue&type=template&id=3d245cd1&scoped=true"
import script from "./FuelItem.vue?vue&type=script&lang=js"
export * from "./FuelItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d245cd1",
  null
  
)

export default component.exports